import { render, staticRenderFns } from "./modal-excluir.vue?vue&type=template&id=597fb562&"
import script from "./modal-excluir.vue?vue&type=script&lang=js&"
export * from "./modal-excluir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports